import { render, staticRenderFns } from "./checkReportHeartLung.vue?vue&type=template&id=27234d14&scoped=true&"
import script from "./checkReportHeartLung.vue?vue&type=script&lang=js&"
export * from "./checkReportHeartLung.vue?vue&type=script&lang=js&"
import style0 from "./checkReportHeartLung.vue?vue&type=style&index=0&id=27234d14&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27234d14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27234d14')) {
      api.createRecord('27234d14', component.options)
    } else {
      api.reload('27234d14', component.options)
    }
    module.hot.accept("./checkReportHeartLung.vue?vue&type=template&id=27234d14&scoped=true&", function () {
      api.rerender('27234d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkReportHeartLung.vue"
export default component.exports